import { render, staticRenderFns } from "./SongLinkForm.vue?vue&type=template&id=907fb98e"
import script from "./SongLinkForm.vue?vue&type=script&lang=js"
export * from "./SongLinkForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports